const ButtonScrollTop = {
	init() {
		const button = document.querySelector('[data-button-scroll-top]');

		if (!button) return;

		button.addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});
	},
};

export default ButtonScrollTop;
